
export enum StatusV2 {
    CART = "CART", // This is the starting staus
    INIT = "INIT", // This is the init payment
    PROCESSING = "PROCESSING",
    OVERBOOKING = "OVERBOOKING",
    ERROR = "ERROR",
    QUOTE = "QUOTE",
    QUOTE_CANCELLED = "QUOTE_CANCELLED",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    CONFIRMED = "CONFIRMED",
    RESERVATION = "RESERVATION"
}
